<template>
  <div
    id="app"
    class="body--inner"
    style="height: 100vh"
    :class="[
      {
        'is-details' : this.$route.name === 'user-details-page',
        'is-login' : this.$route.name === 'login',
        'is-logout' : this.$route.name === 'logout'
      },
      'lang-' + config.lang
    ]"
  >
    <router-view v-if="hideNav" />

    <div
      v-else
      class="contents"
    >
      <masterhead
        v-if="$route.name !== 'login-page'"
      />

      <div
        v-if="$route.name !== 'login-page'"
        class="contents__items contents__sidebar"
      >
        <navigation />
      </div>

      <div class="contents__items contents__body">
        <div class="wrap">
          <div
            v-if="!!(tabs.length)"
            class="tabs"
          >
            <component
              :is="tab.tag"
              v-for="(tab, i) in tabs"
              :key="i"
              :class="`
                ${tab.tag === 'div' ? 'tabs__item' : 'btn--default'}
                ${tab.active === 'true' ? ' is-active' : ''}`
              "
            >
              <router-link
                v-if="tab.path"
                :to="tab.path"
              />

              <span>
                {{ tab.name }}
              </span>
            </component>
          </div>

          <!-- <router-view :key="counter" /> -->
          <router-view />
        </div>
      </div>
    </div>

    <!-- <masterhead
      v-if="showNav()"
      ref="masterhead"
    /> -->

    <!-- <div
      class="masterhead"
      ref="masterhead"
      v-if="showNav()"
    >
      <div class="masterhead__items info-panel">
        <div class="logo"><h1>new sports admin</h1></div>

        <div class="cpanel">
          <div class="cpanel__items -switchtheme">
            <select-list
              :title="theme"
              v-model="theme"
            >
              <select-option
                value="dark"
                name="dark"
              >
                dark
              </select-option>
              <select-option
                value="light"
                name="light"
              >
                light
              </select-option>
            </select-list>
          </div>

          <div class="cpanel__items -switchlang">
            <select-list
              :title="lang"
              v-model="lang"
            >
              <select-option
                value="en"
                name="en"
              >
                en
              </select-option>
              <select-option
                value="jp"
                name="jp"
              >
                jp
              </select-option>
            </select-list>
          </div>

          <div class="cpanel__items -logout">
            <button class="btn--logout">
              <router-link to="/logout"></router-link>
              <span>logout</span>
            </button>
          </div>
        </div>

        <div class="notif-logs">
          <div class="logs-count">
            <span class="logs-count--lbl">cash in</span>
            <span class="logs-count--count">1,000</span>
          </div>

          <div class="logs-count">
            <span class="logs-count--lbl">cash out</span>
            <span class="logs-count--count">1,000</span>
          </div>

          <div class="logs-count">
            <span class="logs-count--lbl">cash wait</span>
            <span class="logs-count--count">1,000</span>
          </div>

          <div class="logs-count">
            <span class="logs-count--lbl">help</span>
            <span class="logs-count--count">1,000</span>
          </div>

          <div class="logs-count">
            <span class="logs-count--lbl">new user</span>
            <span class="logs-count--count">1,000</span>
          </div>

          <div class="logs-count">
            <span class="logs-count--lbl">wait user</span>
            <span class="logs-count--count">1,000</span>
          </div>
        </div>
      </div>

      <div class="masterhead__items statistics">
        <div class="stat-panel">
          <div class="logs-count-title">
            <span>user info</span>
          </div>

          <div class="logs-count">
            <span class="logs-count--lbl">users</span>
            <span class="logs-count--count">1,000</span>
          </div>

          <div class="logs-count">
            <span class="logs-count--lbl">online</span>
            <span class="logs-count--count">1,000</span>
          </div>

          <div class="logs-count">
            <span class="logs-count--lbl">betting</span>
            <span class="logs-count--count">1,000</span>
          </div>

          <div class="logs-count">
            <span class="logs-count--lbl">new</span>
            <span class="logs-count--count">1,000</span>
          </div>
        </div>

        <div class="stat-panel">
          <div class="logs-count-title">
            <span>cash info</span>
          </div>

          <div class="logs-count">
            <span class="logs-count--lbl">in</span>
            <span class="logs-count--count">1,000</span>
          </div>

          <div class="logs-count">
            <span class="logs-count--lbl">out</span>
            <span class="logs-count--count">1,000</span>
          </div>

          <div class="logs-count">
            <span class="logs-count--lbl">net</span>
            <span class="logs-count--count">1,000</span>
          </div>

          <div class="logs-count">
            <span class="logs-count--lbl">users</span>
            <span class="logs-count--count">1,000</span>
          </div>
        </div>

        <div class="stat-panel">
          <div class="logs-count-title">
            <span>betting info</span>
          </div>

          <div class="logs-count">
            <span class="logs-count--lbl">bet</span>
            <span class="logs-count--count">1,000</span>
          </div>

          <div class="logs-count">
            <span class="logs-count--lbl">win</span>
            <span class="logs-count--count">1,000</span>
          </div>

          <div class="logs-count">
            <span class="logs-count--lbl">net</span>
            <span class="logs-count--count">1,000</span>
          </div>

          <div class="logs-count">
            <span class="logs-count--lbl">users</span>
            <span class="logs-count--count">1,000</span>
          </div>
        </div>

        <div class="stat-panel">
          <div class="logs-count-title">
            <span>sports info</span>
          </div>

          <div class="logs-count">
            <span class="logs-count--lbl">bet</span>
            <span class="logs-count--count">1,000</span>
          </div>

          <div class="logs-count">
            <span class="logs-count--lbl">win</span>
            <span class="logs-count--count">1,000</span>
          </div>

          <div class="logs-count">
            <span class="logs-count--lbl">net</span>
            <span class="logs-count--count">1,000</span>
          </div>

          <div class="logs-count">
            <span class="logs-count--lbl">users</span>
            <span class="logs-count--count">1,000</span>
          </div>
        </div>

        <div class="stat-panel">
          <div class="logs-count-title">
            <span>minigame info</span>
          </div>

          <div class="logs-count">
            <span class="logs-count--lbl">bet</span>
            <span class="logs-count--count">1,000</span>
          </div>

          <div class="logs-count">
            <span class="logs-count--lbl">win</span>
            <span class="logs-count--count">1,000</span>
          </div>

          <div class="logs-count">
            <span class="logs-count--lbl">net</span>
            <span class="logs-count--count">1,000</span>
          </div>

          <div class="logs-count">
            <span class="logs-count--lbl">users</span>
            <span class="logs-count--count">1,000</span>
          </div>
        </div>

        <div class="stat-panel">
          <div class="logs-count-title">
            <span>point info</span>
          </div>

          <div class="logs-count">
            <span class="logs-count--lbl">auto</span>
            <span class="logs-count--count">1,000</span>
          </div>

          <div class="logs-count">
            <span class="logs-count--lbl">give</span>
            <span class="logs-count--count">1,000</span>
          </div>

          <div class="logs-count">
            <span class="logs-count--lbl">refund</span>
            <span class="logs-count--count">1,000</span>
          </div>

          <div class="logs-count">
            <span class="logs-count--lbl">net</span>
            <span class="logs-count--count">1,000</span>
          </div>
        </div>

        <div class="stat-panel">
          <div class="logs-count-title">
            <span>manual info</span>
          </div>

          <div class="logs-count">
            <span class="logs-count--lbl">give</span>
            <span class="logs-count--count">1,000</span>
          </div>

          <div class="logs-count">
            <span class="logs-count--lbl">refund</span>
            <span class="logs-count--count">1,000</span>
          </div>

          <div class="logs-count">
            <span class="logs-count--lbl">net</span>
            <span class="logs-count--count">1,000</span>
          </div>

          <div class="logs-count">
            <span class="logs-count--lbl"></span>
            <span class="logs-count--count">1,000</span>
          </div>
        </div>
      </div>
    </div> -- // .masterhead -->

    <!-- <div
      class="contents-wrap"
      :style="`height: ${contentswrap_h}px`"
    >
      <div
        class="contents__items -left"
        :class="{ '-collapsed' : drawer === true }"
        v-if="showNav()"
      >
        <navigation />
      </div>

      <div
        class="contents__items contents__body"
        :class="{ '-expand' : drawer === true }"
        v-if="showNav()"
      >
        <div class="wrap">
          <div class="tabs">
            <component
              v-for="(tabItem, tabKey) in tabs"
              :key="tabKey"
              :is="tabItem.tag"
            >
              <router-link
                v-if="tabItem.path"
                :to="tabItem.path"
              />

              <span>
                {{ tabItem.name }}
              </span>
            </component>
          </div>

          <router-view />
        </div>
      </div>

      <router-view v-else />
    </div> -->
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

//= translation
import { common } from '@/assets/js/translations/Common'

//= mixins
import { detectDevice } from '@/assets/js/mixins/base/DetectDevice'

//= components
import '@/components/base/select/Select'
import Timebox from '@/components/layout/Timebox'
import Masterhead from '@/components/layout/Masterhead'
import Navigation from '@/components/layout/navigation/Navigation'

// lib
// import _includes from 'lodash/includes'

export default {
  name: 'app',

  components: {
    Timebox,
    Navigation,
    Masterhead
  },

  mixins: [
    detectDevice
  ],

  data () {
    return {
      common,
      drawer: false,
      contentswrap_h: null
    }
  },

  computed: {
    ...mapState('config', ['config']),

    hideNav () {
      return (this.$route.name === 'bet-history-matches-page' && this.$route.params.status === 'matches') &&
        this.$route.name === 'support-messages-details-page' &&
        this.$route.name === 'agent-details-page' &&
        this.$route.name === 'user-details-page' &&
        this.$route.name === 'freeboard-details' &&
        this.$route.name === 'logout-page' &&
        this.$route.name === 'login-page'
    },

    tabs () {
      let tabs = []
      const route = this.$route
      const currPath = this.$route.path

      if (route.name === 'admin-logs-page') {
        tabs = [
          // {
          //   name: '사용자',
          //   tag: 'div',
          //   path: '/admin-logs/users/all',
          //   defaultPath: ['/admin-logs/users/all', '/admin-logs/users/insert', '/admin-logs/users/login', '/admin-logs/users/logout', '/admin-logs/users/deleted', '/admin-logs/users/updated']
          // },
          {
            name: '게임',
            tag: 'div',
            path: '/admin-logs/games/all',
            defaultPath: ['/admin-logs/games/all']
          },
          {
            name: '관리자 접속 로그',
            tag: 'div',
            path: '/admin-logs/admin/all',
            defaultPath: ['/admin-logs/admin/all', '/admin-logs/admin/login', '/admin-logs/admin/logout']
          },
          {
            name: '관리자 설정 로그',
            tag: 'div',
            path: '/admin-logs/setting/all',
            defaultPath: ['/admin-logs/setting/all', '/admin-logs/setting/login', '/admin-logs/setting/logout']
          }
          // {
          //   name: '롤링',
          //   tag: 'div',
          //   path: '/admin-logs/rolling/all',
          //   defaultPath: ['/admin-logs/rolling/all']
          // }
        ]
      }

      // if (_includes(['import-agent-page', 'import-user-page', 'import-memo-page'], route.name)) {
      //   tabs = [
      //     {
      //       name: 'agent',
      //       tag: 'div',
      //       path: '/import/agent',
      //       defaultPath: ['/import/agent']
      //     },
      //     {
      //       name: 'user',
      //       tag: 'div',
      //       path: '/import/user',
      //       defaultPath: ['/import/user']
      //     },
      //     {
      //       name: 'memo',
      //       tag: 'div',
      //       path: '/import/memo',
      //       defaultPath: ['/import/memo']
      //     }
      //   ]
      // }

      for (const i in tabs) {
        const currTab = tabs[i]
        const dPath = currTab.defaultPath || this.currPath
        tabs[i].active = 'false'

        if (dPath) {
          for (const x in currTab.defaultPath) {
            const thisPath = currTab.defaultPath[x]

            if (thisPath) {
              if (currPath.indexOf(thisPath) > -1) {
                tabs[i].active = 'true'
              }
            }
          }
        }
      }

      return tabs
    }
  },

  watch: {
    async $route (to, from) {
      this.$nextTick(() => {
        window.addEventListener('resize', this.getContentsWrapHeight)
        this.getContentsWrapHeight()
      })
    }
  },

  async mounted () {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getContentsWrapHeight)
      this.getContentsWrapHeight()
    })
  },

  methods: {
    ...mapActions('config', { getConfig: 'get', updateConfig: 'update' }),

    switchDrawer () {
      this.drawer = !this.drawer
    },

    getContentsWrapHeight () {
      let height = 0
      let masterhead = this.$refs.masterhead ? this.$refs.masterhead.$el : null

      if (masterhead) {
        height = this.device_height - masterhead.offsetHeight
      } else {
        height = this.device_height
      }

      this.contentswrap_h = height
    }
  }
}
</script>
